import axios from "axios";
import { MISMATCHED_TRADES_API, WITH_CREDENTIALS_CONFIG } from "./constants";

export const getMismatchedTrades = () => {
  return axios.get(MISMATCHED_TRADES_API, WITH_CREDENTIALS_CONFIG);
};
